import { createContext, useContext } from "react";
import { useCurrentLocation } from "./useCurrentLocation";

const LocationContext = createContext(null);

export const LocationProvider = ({ children }) => {
  const value = useCurrentLocation();
  return (
    <LocationContext.Provider value={value}>
      {children}
    </LocationContext.Provider>
  );
};

export const useMyLocation = () => useContext(LocationContext);
